<template>
  <v-container fluid class="pa-0 text-center">
    <v-row v-if="isLoggedIn">
      <v-col cols="12">
        <h1>You are already logged in</h1>
        <v-btn
          rounded
          large
          depressed
          color="primary"
          class="mt-12"
          to="/overview"
        >
          <span>Overview page</span><v-icon>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <div v-else>
      <SignupContainer
        :isActivationLink="isActivationLink"
        :isReferralLink="isReferralLink"
        :isPasswordResetLink="isPasswordResetLink"
        :verifyUserLinkCode="verifyUserLinkCode"
      />
    </div>
  </v-container>
</template>

<script>
  import { VERIFY_USER_LINK_CODE_QUERY } from '../../../constants/graphql/users';
  import ResetPassword from './ResetPassword.vue';
  import ActivateAccountPage from './ActivateAccountPage.vue';
  import ReferralAccountPage from './ReferralAccountPage.vue';
  import SignupContainer from '../sign_up/SignupContainer.vue';

  export default {
    name: 'UserLinkLandingPage',
    components: {
      SignupContainer,
      ResetPassword,
      ActivateAccountPage,
      ReferralAccountPage,
    },
    data() {
      return {
        loading: true,
        verifyUserLinkCode: {},
        errorMessage: null,
      };
    },
    computed: {
      isActivationLink() {
        return this.verifyUserLinkCode.linkType == 'ACTIVATION';
      },
      isReferralLink() {
        return this.verifyUserLinkCode.linkType == 'REFERRAL';
      },
      isPasswordResetLink() {
        return this.verifyUserLinkCode.linkType == 'RESET_PASSWORD';
      },
    },
    methods: {
      setCookies() {
        if (this.isReferralLink) {
          this.$cookies.set('referralCode', this.$route.params.id, '1d');
        }
      },
    },
    apollo: {
      verifyUserLinkCode: {
        query: VERIFY_USER_LINK_CODE_QUERY,
        variables() {
          return {
            code: this.$route.params.id,
          };
        },
        skip() {
          return this.isLoggedIn;
        },
        fetchPolicy: 'network-only',
        result(response) {
          if (response.data) {
            if (!response.data.verifyUserLinkCode) {
              this.errorMessage =
                'Sorry, something went wrong. Please try reloading the page.';
            } else if (!response.data.verifyUserLinkCode.validCode) {
              if (
                response.data.verifyUserLinkCode.used &&
                response.data.verifyUserLinkCode.email
              ) {
                this.$cookies.remove('referralCode');
                this.$router.push({
                  name: 'Login',
                  params: {
                    prepopulatedEmail: response.data.verifyUserLinkCode.email,
                  },
                });
              } else {
                this.errorMessage =
                  'Sorry, this reset password link has expired or is invalid.';
              }
            }
            this.$store.dispatch('setCoBrandingUrl', {
              companyOffersFreeWill:
                response.data.verifyUserLinkCode.companyOffersFreeWill,
              url: response.data.verifyUserLinkCode.companyLogoUrl,
              name: response.data.verifyUserLinkCode.companyName,
              bannerTitle: response.data.verifyUserLinkCode.bannerTitle,
              bannerDescription:
                response.data.verifyUserLinkCode.bannerDescription,
            });
            this.setCookies();
            this.loading = false;
          }
        },
      },
    },
  };
</script>
